import KunLoading55 from './src/index'

KunLoading55.install = function (Vue) {
	Vue.component(KunLoading55.name, KunLoading55);
}

export default KunLoading55;
